import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';

import Content from 'builder/Knowledge/pages/Content';
import KnowledgeHelpMenu from 'builder/Knowledge/components/KnowledgeHelpMenu';

const Knowledge = ({ match, knowledgeMap }) => (
  <React.Fragment>
    <Switch>
      <Route
        exact
        path={`${match.url}/content/:itemId`}
        render={({ match: subMatch, history }) => (
          <Content
            knowledgeMap={knowledgeMap}
            selectedItemId={subMatch.params.itemId}
            historyPush={history.push}
          />
        )}
      />
      <Route
        path={`${match.url}/content`}
        render={({ history }) => (
          <Content
            knowledgeMap={knowledgeMap}
            historyPush={history.push}
          />
        )}
      />
    </Switch>
    <KnowledgeHelpMenu />
  </React.Fragment>
);

Knowledge.propTypes = {
  match: PropTypes.object,
  knowledgeMap: PropTypes.object,
};

export default Knowledge;
